module.exports = __webpack_public_path__ + "static/media/menuHandler.6c6332ca.svg";